import { ColorConstants } from "../../../../constants";

export type PortfolioRoadmapRowLabelData = {
  displayName: string;
  subtitle?: string;
  uuid: string;
  additionalDates: boolean;
}[];

export type ChartReferenceNodes = {
  tooltipClone?: HTMLElement;
  timelineClone?: SVGElement;
  bars?: SVGElement;
  highlightBars?: SVGElement;
};

export enum ViewMode {
  Months1 = "months1",
  Months3 = "months3",
  Months6 = "months6",
  Years1 = "years1",
  Years2 = "years2",
}

export const PIPELINE_PHASE_COLOR_PAIRS: [string, string][] = [
  [ColorConstants.VIOLET_500, ColorConstants.VIOLET_500],
  [ColorConstants.SKY_BLUE_500, ColorConstants.SKY_BLUE_500],
  [ColorConstants.AMBER_ORANGE_500, ColorConstants.AMBER_ORANGE_500],
  [ColorConstants.AQUA_500, ColorConstants.AQUA_500],
  [ColorConstants.GOLDENROD_500, ColorConstants.GOLDENROD_500],
  [ColorConstants.BLUE_500, ColorConstants.BLUE_500],
  [ColorConstants.MAGENTA_500, ColorConstants.MAGENTA_500],
  [ColorConstants.GOLDENROD_600, ColorConstants.GOLDENROD_600],
  [ColorConstants.SKY_BLUE_600, ColorConstants.SKY_BLUE_600],
  [ColorConstants.MINT_GREEN_500, ColorConstants.MINT_GREEN_500],
];

export const PIPELINE_MILESTONE_COLORS: string[] = [
  ColorConstants.VIOLET_200,
  ColorConstants.SKY_BLUE_200,
  ColorConstants.AMBER_ORANGE_200,
  ColorConstants.AQUA_200,
  ColorConstants.GOLDENROD_200,
  ColorConstants.BLUE_200,
  ColorConstants.MAGENTA_200,
  ColorConstants.GOLDENROD_200,
  ColorConstants.SKY_BLUE_200,
  ColorConstants.MINT_GREEN_200,
];

export const PIPELINE_MILESTONE_COLOR_MAP: Record<string, string> = {
  [ColorConstants.VIOLET_200]: ColorConstants.VIOLET_500,
  [ColorConstants.SKY_BLUE_200]: ColorConstants.SKY_BLUE_500,
  [ColorConstants.AMBER_ORANGE_200]: ColorConstants.AMBER_ORANGE_500,
  [ColorConstants.AQUA_200]: ColorConstants.AQUA_500,
  [ColorConstants.GOLDENROD_200]: ColorConstants.GOLDENROD_500,
  [ColorConstants.BLUE_200]: ColorConstants.BLUE_500,
  [ColorConstants.MAGENTA_200]: ColorConstants.MAGENTA_500,
  [ColorConstants.MINT_GREEN_200]: ColorConstants.MINT_GREEN_500,
};
